// Commercial Readiness Check — shared between the Recipe Builder (label panel)
// and the Commercialization Center hub. Checks that the common required label
// elements are present before printing. Deliberately NOT a compliance
// guarantee; it verifies presence, not legal sufficiency.
// Returns { checks: [{label, status: pass|warn|fail, note}], score }.
export function computeLabelReadiness({ calc, bp, netWeight, productName }) {
  const checks = [];
  const add = (label, status, note = "") => checks.push({ label, status, note });

  add("Product name present", productName ? "pass" : "fail",
    productName ? "" : "Add a product name — required on the front panel");
  add("Net quantity present", netWeight ? "pass" : "fail",
    netWeight ? "" : "Enter a net weight — FDA requires a net quantity statement");
  add("Nutrition Facts generated", calc?.nutrition ? "pass" : "fail");
  add("Ingredients listed in descending order", calc?.statement?.statement ? "pass" : "fail",
    calc?.statement?.statement ? "Ordered by weight automatically" : "Add ingredients");
  add("Allergens declared",
    calc?.statement?.contains_line ? "pass" : (calc?.statement?.statement ? "warn" : "fail"),
    calc?.statement?.contains_line ? "" :
      "No major allergens detected — verify none of your ingredients contain undeclared allergens");
  add("Manufacturer / distributor info present",
    (bp?.legal_entity && bp?.address_line1 && bp?.city) ? "pass" : "fail",
    (bp?.legal_entity && bp?.address_line1 && bp?.city) ? "" :
      "Complete your business profile — FDA requires the responsible party's name and address");
  add("Country of origin", bp?.country ? "pass" : "warn",
    bp?.country ? "" : "Required for imported products — set it in your business profile");
  if (calc?.claims?.length > 0) {
    add("Claims identified", "warn",
      `${calc.claims.length} claim${calc.claims.length > 1 ? "s" : ""} on this label — documentation should be maintained to support labeling claims`);
  }
  const required = checks.filter((c) => c.status !== "warn");
  const passed = required.filter((c) => c.status === "pass").length;
  const warns = checks.filter((c) => c.status === "warn").length;
  const score = Math.round(((passed + warns * 0.5) / (required.length + warns)) * 100);
  return { checks, score };
}

// Score → 🟢/🟡/🔴 headline status. Shared so the builder panel and the
// Commercialization Center always agree.
export function readinessStatus(score) {
  return score >= 95
    ? { dot: "🟢", text: "Commercial Ready", cls: "text-emerald-700" }
    : score >= 75
    ? { dot: "🟡", text: "Needs Review", cls: "text-amber-600" }
    : { dot: "🔴", text: "Incomplete", cls: "text-red-700" };
}
